export default {
  cargoLoadType: 'بار',
  furnitureLoadType: 'اسباب‌کشی',
  postageLoadType: 'مرسوله پستی',
  clientTypes: {
    WEB: 'وبسایت',
    WEB_ADMIN: 'وبسایت-پنل ادمین',
    WEB_COMPANY: 'وبسایت-پنل باربری',
    WEB_DRIVER: 'وبسایت-پنل راننده',
    DESKTOP: 'دسکتاپ',
    ANDROID: 'اپ اندروید',
    ANDROID_PWA: 'اپ اندروید (PWA)',
    ANDROID_WEB_VIEW: 'اپ اندروید (WebView)',
    ANDROID_ADMIN: 'اپ اندروید-ادمین',
    ANDROID_ADMIN_PWA: 'اپ اندروید-ادمین (PWA)',
    ANDROID_ADMIN_WEB_VIEW: 'اپ اندروید-ادمین (WebView)',
    ANDROID_COURIER: 'اپ اندروید-باربری',
    ANDROID_COURIER_PWA: 'اپ اندروید-باربری (PWA)',
    ANDROID_COURIER_WEB_VIEW: 'اپ اندروید-باربری (WebView)',
    ANDROID_DRIVER: 'اپ اندروید-راننده',
    ANDROID_DRIVER_PWA: 'اپ اندروید-راننده (PWA)',
    ANDROID_DRIVER_WEB_VIEW: 'اپ اندروید-راننده (WebView)',
    IOS: 'اپ IOS',
    IOS_PWA: 'اپ IOS (PWA)',
    IOS_WEB_VIEW: 'اپ IOS (WebView)'
  },
  pricingTypes: {
    courierTariff: 'قیمت دهی تعرفه‌ای باربری',
    auction: 'قیمت دهی مزایده‌ای',
    webservice: 'قیمت دهی وب‌سرویس',
    systemTariff: 'قیمت دهی تعرفه‌ای سیستمی'
  },
  loadTypes: {
    furniture: 'اسباب‌کشی',
    cargo: 'بار سنگین',
    postalPostage: 'مرسوله پستی',
    delivery: 'پیک',
    pickup: 'وانت',
    material: 'مصالح',
    trash: 'نخاله',
    freight: 'پیک بادپا'
  },
  loadRanges: {
    urban: 'شهری',
    intercity: 'بین‌شهری'
  },
  loadStates: {
    pricingPending: 'منتظر قیمت دهی',
    acceptPending: 'منتظر تایید',
    confirmed: 'تایید شده',
    started: 'جاری',
    finished: 'پایان'
  },
  os: {
    windows: 'ویندوز',
    mac: 'مکینتاش',
    linux: 'لینوکس',
    android: 'اندروید',
    apple: 'اپل',
    unix: 'یونیکس',
    undefined: 'نامشخص'
  },
  financial: {
    reject: 'رد شده',
    draft: 'پیشنویس',
    pending: 'منتظر تایید',
    approved: 'تائید شده',
    general: 'عمومی',
    limit: 'محدود',
    paid: 'پرداخت شده',
    didntPay: 'پرداخت نشده'
  },
  opinion: {
    reject: 'رد شده',
    pending: 'در انتظار بررسی',
    inProgress: 'در حال پیگیری',
    approved: 'تائید شده',
    cons: 'نقاط ضعف',
    pros: 'نقاط قوت'
  },
  message: {
    unicast: 'Unicast',
    multicast: 'Multicast',
    broadcast: 'Broadcast'
  },
  dictionary: {
    city: 'شهر',
    province: 'استان',
    parcelSize: 'سایز بسته',
    carLoad: 'بارگیر',
    load: 'نوع بار',
    package: 'نوع بسته بندی',
    chapar: 'چاپار',
    mahex: 'ماهکس',
    postex: 'پستکس',
    ecopeyk: 'اکوپیک',
    deca: 'دکابار',
    dictionary: 'دیکشنری',
    webservice: 'وب سرویس'
  },
  days: {
    saturday: 'شنبه',
    sunday: 'یک شنبه',
    monday: 'دوشنبه',
    tuesday: 'سه شنبه',
    wendesday: 'چهارشنبه',
    thursday: 'پنج شنبه',
    friday: 'جمعه'
  },
  log: {
    report: 'گزارش',
    detail: 'جزئیات',
    index: 'شاخص گذاری',
    export: 'خروجی اکسل',
    instantiate: 'ساختن از روی الگو/نمونه',
    editImage: 'ویرایش تصویر',
    create: 'درج',
    update: 'ویرایش',
    delete: 'حذف',
    generate: 'تولید',
    import: 'درج انبوه',
    upsert: 'درج-ویرایش',
    logicalDelete: 'حذف منطقی',
    enable: 'فعال‌سازی',
    disable: 'غیر فعال‌سازی',
    patch: 'ویرایش اندک'
  },
  reasonType: {
    cancelOrder: 'لغو سفارش',
    suspendAccount: 'تعلیق حساب کاربری',
    deleteAccount: 'حذف حساب کاربری',
    courierBlackList: 'لیست سیاه باربری',
    driverBlackList: 'لیست سیاه راننده'
  },
  priority: {
    unknown: 'نامشخص',
    low: 'پایین',
    normal: 'متوسط',
    high: 'بالا',
    urgent: 'فوری'
  },
  plateType: {
    car: 'سواری',
    motorcycle: 'موتور سیکلت'
  },
  fuelType: {
    petrol: 'بنزین',
    gasoline: 'گازوئیل'
  },
  weather: {
    rainy: 'بارانی',
    snowy: 'برفی',
    foggy: 'مه آلود',
    frost: 'یخبندان'
  },
  educationLevel: {
    primarySchool: 'ابتدایی',
    middleSchool: 'سیکل',
    diploma: 'دیپلم',
    associate: 'کاردانی',
    bsc: 'کارشناسی',
    msc: 'کارشناسی ارشد',
    phd: 'دکتری تخصصی',
    postdoc: 'پسا دکتری'
  },
  openBankingPaymentTransferStatus: {
    waitForCustomerAccept: 'در انتظار تایید مشتری',
    waitForBranchAccept: 'در انتظار تایید شعبه',
    branchReject: 'رد شده از طرف شعبه',
    readyToTransfer: 'آماده‌ی ارسال',
    suspend: 'معلق',
    cancel: 'لغو شده',
    processed: 'انجام شده'
  },
  openBankingPaymentType: {
    normal: 'درون بانکی',
    ach: 'پایا',
    rtgs: 'ساتنا'
  }
}
